import React from "react";

const CaseStudyAreaTwo = () => {
  return (
    <>
      {/*================== case-study area start ==================*/}
      <div className="case-study-area pd-top-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="section-title text-center">
                <h6 className="sub-title-sky-blue">工作展示</h6>
                <h2 className="title">未来科技成品</h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-4 col-xs-4">
              <div className="single-case-study-inner style-2">
                <div className="thumb">
                  <img src="assets/img/chess.webp" alt="img" />
                </div>
                <div className="details">
                  <h5>国际象棋</h5>
                  <p>英国</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-xs-4">
              <div className="single-case-study-inner style-2">
                <div className="thumb">
                  <img src="assets/img/aviation.webp" alt="img" />
                </div>
                <div className="details">
                  <h5>航空控制台</h5>
                  <p>越南</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-xs-4">
              <div className="single-case-study-inner style-2">
                <div className="thumb">
                  <img src="assets/img/autonomous.webp" alt="img" />
                </div>
                <div className="details">
                  <h5>自动驾驶</h5>
                  <p>德国</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-4 col-xs-4">
              <div className="single-case-study-inner style-2">
                <div className="thumb">
                  <img src="assets/img/neural.webp" alt="img" />
                </div>
                <div className="details">
                  <h5>捷运站</h5>
                  <p>中国</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-xs-4">
              <div className="single-case-study-inner style-2">
                <div className="thumb">
                  <img src="assets/img/farm.webp" alt="img" />
                </div>
                <div className="details">
                  <h5>自动化农场</h5>
                  <p>荷兰</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-xs-4">
              <div className="single-case-study-inner style-2">
                <div className="thumb">
                  <img src="assets/img/warehouse.webp" alt="img" />
                </div>
                <div className="details">
                  <h5>货仓</h5>
                  <p>美国</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================== case-study area end ==================*/}
    </>
  );
};

export default CaseStudyAreaTwo;
